export default "<router-outlet></router-outlet>\n<ngx-spinner></ngx-spinner>"